import React from "react";

import { LinkProps } from "./Link.types";

import "./Link.scss";

const Link: React.FC<LinkProps> = ({
  component,
  children,
  rel,
  target,
  to,
  type,
}) => {
  const Component = component || "a";

  return (
    <Component
      data-testid="Link"
      className={`mp-atoms-link--main ${type}`}
      {...(component ? { to } : { href: to })}
      rel={rel}
      target={target}
    >
      {children}
    </Component>
  );
};

export default Link;

// https://tsh.io/blog/atomic-design-explained-by-ryan-reynolds/
